type WorldType = {
  fill: string
  width: string
  height: string
  title: string
}
function World(props: WorldType) {
  const fill = props.fill || 'currentColor'
  const width = props.width || '1em'
  const height = props.height || '1em'
  const title = props.title || 'world'

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
    >
      <title>{title}</title>
      <g fill={fill} strokeLinecap='butt' strokeLinejoin='miter'>
        <polyline
          fill='none'
          points='5.11 3.425 6.722 4.75 8.367 6.506 7.963 9.246 5.369 10.558 4 11.726 4.667 12.864 5.974 14.264 6.68 16.737 4.717 18.384 4.358 19.912'
          stroke={fill}
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
        <polyline
          fill='none'
          points='20.32 4.805 18.843 5.643 15.843 6 13.559 4.162 12.939 2.349 12.127 1'
          stroke={fill}
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
        <polygon
          fill='none'
          points='19.007 12.903 18.079 15.001 17.125 17.152 15.362 18.793 13.023 18.943 11.629 17.253 12.097 15.083 11.694 12.94 13.287 10.943 15.514 10.161 17.872 10.725 19.007 12.903'
          stroke={fill}
          strokeLinecap='square'
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
        <circle
          cx='12'
          cy='12'
          fill='none'
          r='11'
          stroke={fill}
          strokeLinecap='square'
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
      </g>
    </svg>
  )
}

export default World
